module.exports = __webpack_public_path__ + "img/chris_g_26.960567c0.jpg";